import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export interface RedirectionConfiguration {
  enableLoginPageRedirection: boolean;
  enableLandingPageRedirection: boolean;
  buyerLandingPageUrl: string;
  supplierLandingPageUrl: string;
  legacyWelcomePage: string;
  chineselegacyWelcomePage: string;
  chineseBuyerLandingPageUrl: string;
  chineseSupplierLandingPageUrl: string;
}

@Injectable({
  providedIn: 'root'
})

export class RedirectionServiceService {

constructor()  { }
  REDIRECT_FLAG = 'hasRedirectionOccurred';
  
  readonly config: RedirectionConfiguration = {
    enableLoginPageRedirection: environment.redirectionOptions.enableLoginPageRedirection,
    enableLandingPageRedirection: environment.redirectionOptions.enableLandingPageRedirection,
    buyerLandingPageUrl: environment.redirectionOptions.buyerLandingPageUrl,
    supplierLandingPageUrl: environment.redirectionOptions.supplierLandingPageUrl,
    chineseBuyerLandingPageUrl: environment.redirectionOptions.chineseBuyerLandingPageUrl,
    chineseSupplierLandingPageUrl: environment.redirectionOptions.chineseSupplierLandingPageUrl,
    legacyWelcomePage: environment.redirectionOptions.legacyWelcomePage,
    chineselegacyWelcomePage: environment.redirectionOptions.chineselegacyWelcomePage,
  };

  checkRedirectionNeeded(): boolean {
    if (this.config.enableLandingPageRedirection === true) {
      return localStorage.getItem(this.REDIRECT_FLAG) !== 'true';
    }
    return false;
  }

  initialize(): void {
     localStorage.setItem(this.REDIRECT_FLAG, 'true');
  }

  cleanUp(): void {
      localStorage.removeItem(this.REDIRECT_FLAG);
  }

}
